module.exports = __webpack_public_path__ + "assets/31c9acbf4926ec21938b4f29e8f7d2a3.mp3";